import React, {useState, useEffect, useCallback } from 'react';
import { Container, Col, Row, Dropdown} from 'react-bootstrap';
import Jobseekersgraph from './Jobseekersgraph';
import Employergraph from './Employergraph';
import * as ascentwebApi from "../../api/ascentwebApi"
import * as misReportApi from "../../api/misReportApi"
import { useSignalAbort } from "../../api/useSignalAbort";
import { Spinner } from 'react-bootstrap';
import { handleApiErrors } from '../../api/handleApiErrors';

function Livetalent() {
  const abortConstants = useSignalAbort()
  const [selectedItem, setSelectedItem] = useState("");
  const [Country,setCountry] = useState()
  const [Countryselect,setCountryselect] = useState(0)
  const [CandidateAvailability, setCandidateAvailability] = useState()
  const [EmployerAvailability, setEmployerAvailability] = useState()
  const [isLoading, setIsLoading] = useState({})
  
  //getCountry
  const getCountry = async (abortToken) => {
    try {
      const result = await ascentwebApi.getCountry(Countryselect, abortToken);
      console.log(result?.data?.Country);
      setCountry(result?.data?.Country);
      setCountryselect(result?.data?.Country[0].countryId)
      console.log(result?.data?.Country[0].countryId);
      getCandidateAvailability(result?.data?.Country[0].countryId, abortToken);
      getEmployerAvailability(result?.data?.Country[0].countryId, abortToken);
    } catch (error) {
      handleApiErrors(error, 'Country', 'country_response', 'country_timeout', 'country_request', setIsLoading)
    }
  };

  //CandidateAvailability
  const getCandidateAvailability = async (id, abortToken) => {
    try {
      const result = await misReportApi.getCandidateAvailability(id, abortToken);
      console.log(result?.data?.MISReport);
      setCandidateAvailability(result?.data?.MISReport);
    } catch (error) {
      handleApiErrors(error, 'Candidate Availability', 'candidateavailability_response', 'candidateavailability_timeout', 'candidateavailability_request', setIsLoading)
    }
  };
//EmployerAvailability
const getEmployerAvailability = async (id, abortToken) => {
  try {
    const result = await misReportApi.getEmployerAvailability(id, abortToken);
    console.log(result?.data?.MISReport);
    setEmployerAvailability(result?.data?.MISReport);
  } catch (error) {
    handleApiErrors(error, 'Employer Availability', 'employeravailability_response', 'employeravailability_timeout', 'employeravailability_request', setIsLoading)
  }
};

  const getAllData = useCallback((abortToken) => {
    getCountry(abortToken);

  }, []);
  

  useEffect(() => {
    getAllData(abortConstants.controllerConfig);

    // return () => {
    //   // Cleanup logic if needed
    //   abortConstants.controller.abort();
    // };
  }, [getAllData]);

  const handleCountryselect = (e) => {
    console.log(e.target.value);
    setCountryselect(e.target.value);
    // console.log(Countryselect);
  }

  
  const handleSelect = (eventKey ,value) => {
    console.log(eventKey);
    setSelectedItem(eventKey);
    console.log(value);
    getCandidateAvailability(value, abortConstants.controllerConfig);
    getEmployerAvailability(value, abortConstants.controllerConfig)
    setCountryselect(eventKey)
  };

  const CustomDropdownItem = ({ eventKey, children, value }) => (
    <Dropdown.Item eventKey={eventKey} onClick={() => handleSelect(eventKey, value)}>
      {children}
    </Dropdown.Item>
  );
  
  const renderLoading = (item) => {
    if (isLoading[`${item}_response`] || isLoading[`${item}_request`] || isLoading[`${item}_timeout`] ) {
      return true
    }
    else {
      return false
    }
  }
  
  //Styles
  const captionStyle = {
    textAlign: 'center',
    padding: '2px',
  };

  const captionTextStyle = {
    fontSize: '2rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#2855A1',
    marginTop: '2rem',
  };

  const captionTextStyleCard = {
    fontSize: '1rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#2855A1',
    marginTop: '2rem',
  };

  const captionTextStyle2 = {
    fontSize: '2rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: 'black',
  };

  const captionTextStyleP = {
    fontSize: '1.5rem',
    marginTop: '3rem',
    textOverflow: 'ellipsis',
    color: 'black',
  };

  // Define a base style for the dropdown
const baseDropdownStyle = {
  width: '250px',
  height: '60px',
  color: 'black',
  backgroundColor: 'white',
  border: 'none',
  borderRadius: '10px',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '15px',
  fontWeight: 600,
  marginBottom: '50px',
};


  const graphHeight = {
    height: 'auto',
  };
  

  const cardStyle = {
    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)', // Increase the box shadow
  };

  
  return (
    <Container
      fluid
      style={{ backgroundColor: "#F7F9FF", marginTop: "80px", height: "auto" }}
    >
      <Container style={{ padding: "2px" }}>
        <div style={captionStyle}>
          <h3 style={captionTextStyle}>
            Live Talent <span style={captionTextStyle2}>Metrics</span>
          </h3>
          <p style={captionTextStyleP}>
            Explore Real-Time, Interactive Data on Candidate Availability Across
            Countries And Regions
          </p>
        </div>
      </Container>

      <Container style={{ marginTop: "20px" }}>
        <Row className="justify-content-center">
          <Col xs={5} className="justify-content-center">
            <Container className="mt-3 mt-sm-0 md-left-0 ml-0">
              <Dropdown
                name="Country"
                value={Countryselect}
                onChange={handleCountryselect}
              >
                <Dropdown.Toggle
                  variant="outline-primary"
                  id="dropdown-basic"
                  style={baseDropdownStyle}
                >
                  {selectedItem}
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ width: "250px", textAlign: "left" }}>
                {Country ? (
                          <>
                            {Country.length !== 0 ? (
                              <>
                                {Country.map((item) => (
                                 <CustomDropdownItem
                                 key={item.countryName}
                                 eventKey={item.countryName}
                                 name={item.countryName}
                                 value={item.countryId}
                               >
                                 {item.countryName}
           
                                 <Dropdown.Divider />
                               </CustomDropdownItem>
                                ))}
                                 {selectedItem === "" && setSelectedItem(Country[0].countryName)}
                              </>
                            ) : (
                              <h4 style={{ textAlign: "center" }}>No data</h4>
                            )}
                          </>
                        ) : (
                          <>
                            {renderLoading("country") && (
                              <h5 style={{ textAlign: "center" }}>No data</h5>
                            )}
                          </>
                        )}
                </Dropdown.Menu>
              </Dropdown>
            </Container>
          </Col>
          <Col xs={5} className="justify-content-center"></Col>
          <Col xs={12} sm={12} md={12} lg={5}>
            <Container
              className="mt-3 mt-sm-0"
              style={{
                ...graphHeight,
                marginTop: "20px",
                marginBottom: "50px",
              }}
            >
              <div className="card" style={{ ...captionStyle, ...cardStyle }}>
                <div className="card-body">
                  <h5 className="card-title" style={captionTextStyleCard}>
                    {/* Job Seekers */}
                  </h5>
                </div>
                <div style={graphHeight}>
                {CandidateAvailability ? (
                  <>
                  {CandidateAvailability.length !== 0 ? (
                  <Jobseekersgraph CandidateAvailability={CandidateAvailability} />
                  ) : (
                    <div style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'  }}>
                    No data
                  </div>
                    )}
                 </>
                    ) : (
                      <>
                        {renderLoading("candidateavailability") || renderLoading("country") || (CandidateAvailability===null) ? (
                          <div style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'  }}>
                            No data                        
                            </div>
                        ) : (
                          <div style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'  }}>
                            <Spinner animation="border" role="status" style={{ color: '#2855A1' }} />
                          </div>
                        )}
                      </>
                    )}
                </div>
              </div>
            </Container>
          </Col>

          <Col xs={12} sm={12} md={12} lg={5}>
            <Container
              className="mt-3 mt-sm-0"
              style={{
                ...graphHeight,
                marginTop: "20px",
                marginBottom: "50px",
              }}
            >
              <div className="card" style={{ ...captionStyle, ...cardStyle }}>
                <div className="card-body">
                  <h5 className="card-title" style={captionTextStyleCard}>
                    {/* Employers */}
                  </h5>
                </div>
                <div style={graphHeight}>
                {EmployerAvailability ? (
                  <>
                  {EmployerAvailability.length !== 0 ? (
                  <Employergraph EmployerAvailability={EmployerAvailability} />
                  ) : (
                      <h4 style={{ textAlign: "center" }}>No data</h4>
                    )}
                 </>
                    ) : (
                      <>
                        {renderLoading("employeravailability") || renderLoading("country") ? (
                          <div style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'  }}>
                          No data                        
                          </div>
                        ) : (
                          <div style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'  }}>
                            <Spinner animation="border" role="status" style={{ color: '#2855A1' }} />
                          </div>
                        )}
                      </>
                    )}
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Livetalent;
